import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { MeasureModule } from './measure/measure.module';
import { GeoPortaleModule } from './geo-portale/geo-portale.module';
import { WidgetsComponent } from './tools.component';
import { BaseMapSwitchComponent } from './base-map-switch/base-map-switch.component';
import { LayerControlComponent } from './layer-control/layer-control.component';
import { LegendComponent } from './legend/legend.component';
import { MassStabSliderComponent } from './massstab-slider/massstab-slider.component';
import { PrintComponent } from './print/print.component';
import { ShareComponent } from './share/share.component';
import { DrawModule } from './draw/draw.module';
import { SearchParzelleComponent } from './search-parzelle/search-parzelle.component';
import { GoToComponent } from './go-to/go-to.component';
import { ScaleBarComponent } from './scale-bar/scale-bar.component';
import { PopupModule } from './popup/popup.module';
import { LayerOpacityComponent } from './layer-control/layer-opacity/layer-opacity.component';
import { SearchHektometerComponent } from './search-hektometer/search-hektometer.component';
import { DragDropModule } from '../../core/drag-drop/drag-drop.module';
import { LayerInfoComponent } from './layer-control/layer-info/layer-info.component';
import { LayerDefinitionExpressionComponent } from './layer-control/layer-definition-expression/layer-definition-expression.component';
import { SharedModule } from '../../shared/shared.module';
import { SbbPrintModule } from '@sbb-amsgis/sbb-print';
import { GoogleMapsToolModule } from './google-maps-tool-module/google-maps-tool.module';
import { CommonModule } from '@angular/common';

export const SINGLE_TOOL_COMPONENTS = [
  WidgetsComponent,
  GoToComponent,
  BaseMapSwitchComponent,
  LayerControlComponent,
  LegendComponent,
  LayerOpacityComponent,
  ScaleBarComponent,
  MassStabSliderComponent,
  PrintComponent,
  SearchParzelleComponent,
  ShareComponent,
  SearchHektometerComponent,
  LayerInfoComponent,
  LayerDefinitionExpressionComponent,
];

@NgModule({
  declarations: [SINGLE_TOOL_COMPONENTS],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DrawModule,
    GeoPortaleModule,
    PopupModule,
    TypeaheadModule.forRoot(),
    MeasureModule,
    DragDropModule,
    SharedModule,
    SbbPrintModule,
    GoogleMapsToolModule,
  ],
  exports: [SINGLE_TOOL_COMPONENTS, DrawModule, GeoPortaleModule, PopupModule, MeasureModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ToolsModule {}
